import React from 'react';
import { Phone, Mail, Clock, Star } from 'lucide-react';
import { COMPANY } from '../mock';

const TopBar = () => {
  return (
    <div className="hidden md:block bg-[color:var(--mv-navy)] text-white text-sm">
      <div className="container-xl flex items-center justify-between py-2.5">
        <div className="flex items-center gap-6 opacity-95">
          <span className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-[color:var(--mv-orange-2)]" />
            {COMPANY.hours}
          </span>
          <span className="flex items-center gap-2">
            <Mail className="w-4 h-4 text-[color:var(--mv-orange-2)]" />
            {COMPANY.email}
          </span>
        </div>
        <div className="flex items-center gap-6">
          <span className="flex items-center gap-1.5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-3.5 h-3.5 fill-[color:var(--mv-yellow)] text-[color:var(--mv-yellow)]" />
            ))}
            <a href="https://www.google.com/maps/search/?api=1&query=Movevan%20LTD%2007985291097" target="_blank" rel="noopener noreferrer" aria-label="Five stars. Read our reviews on Google (opens in a new tab)" className="ml-1 text-white/80 underline underline-offset-2" data-testid="topbar-reviews-link">Reviews on Google</a>
          </span>
          <a href={`tel:${COMPANY.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 font-semibold hover:text-[color:var(--mv-orange-2)] transition-colors">
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
